module.exports = __webpack_public_path__ + "static/media/case.9004a4ca.svg";